(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[803],{

/***/ 29973:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), 'ArrowForward');

exports.Z = _default;

/***/ }),

/***/ 91221:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/category/[slug]",
      function () {
        return __webpack_require__(85249);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ArticleListSection_ArticleListSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/CMS/ArticlePublisher/index.tsx
var ArticlePublisher = __webpack_require__(62173);
// EXTERNAL MODULE: ./components/CMS/CmsImage/index.ts + 2 modules
var CmsImage = __webpack_require__(78868);
// EXTERNAL MODULE: ./constants/path.ts
var path = __webpack_require__(96703);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./components/Image/index.tsx + 2 modules
var Image = __webpack_require__(87113);
// EXTERNAL MODULE: ./components/CMS/ArticleItemTop/ArticleItemTop.module.scss
var ArticleItemTop_module = __webpack_require__(2812);
var ArticleItemTop_module_default = /*#__PURE__*/__webpack_require__.n(ArticleItemTop_module);
;// CONCATENATED MODULE: ./components/CMS/ArticleItemTop/ArticleItemTop.tsx









var ArticleItemTop = function(param) {
    var article = param.article;
    var ref;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("article", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ArticleItemTop_module_default()).box,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "".concat(path/* PATH.ARTICLES */.m.ARTICLES, "/").concat(article.slug),
                as: "".concat(path/* PATH.ARTICLES */.m.ARTICLES, "/").concat(article.slug),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: (ArticleItemTop_module_default()).link,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ArticleItemTop_module_default()).cover,
                            children: [
                                article.cover ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CmsImage/* default */.Z, {
                                    altText: article.cover.alternativeText || Image/* defaultAlt */.Zp,
                                    imageProps: article.cover,
                                    format: "small",
                                    layout: "fill"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (ArticleItemTop_module_default()).cover__error,
                                    children: "Failed to load image..."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ArticleItemTop_module_default()).topLeft,
                                    children: (ref = article.article_category) === null || ref === void 0 ? void 0 : ref.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ArticleItemTop_module_default()).titleH2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h6",
                                component: "h2",
                                children: article.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ArticleItemTop_module_default()).blurb,
                            children: article.blurb
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePublisher/* ArticlePublisher */.n, {
                            author: article.author,
                            publishedDate: article.published_date
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var ArticleItemTop_ArticleItemTop = (ArticleItemTop);

;// CONCATENATED MODULE: ./components/CMS/ArticleItemTop/index.tsx


// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./components/CMS/ArticleListSection/ArticleListSection.module.scss
var ArticleListSection_module = __webpack_require__(59565);
var ArticleListSection_module_default = /*#__PURE__*/__webpack_require__.n(ArticleListSection_module);
;// CONCATENATED MODULE: ./components/CMS/ArticleListSection/ArticleListSection.tsx






var ArticleListSection = function(param) {
    var articles = param.articles, articleListTitle = param.articleListTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ArticleListSection_module_default()).container,
        children: [
            articleListTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ArticleListSection_module_default()).titleContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h5",
                    component: "h2",
                    children: articleListTitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                spacing: 3,
                children: articles.map(function(article) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        sm: 4,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleItemTop_ArticleItemTop, {
                            article: article
                        })
                    }, article.id);
                })
            })
        ]
    });
};
/* harmony default export */ var ArticleListSection_ArticleListSection = (ArticleListSection);

;// CONCATENATED MODULE: ./components/CMS/ArticleListSection/index.tsx



/***/ }),

/***/ 31819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ ArticleResultLanding; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/CMS/ArticleListSection/index.tsx + 3 modules
var ArticleListSection = __webpack_require__(96386);
// EXTERNAL MODULE: ./components/CMS/CmsImage/index.ts + 2 modules
var CmsImage = __webpack_require__(78868);
// EXTERNAL MODULE: ./components/CMS/LinkElement/index.tsx
var LinkElement = __webpack_require__(7098);
// EXTERNAL MODULE: ./components/CMS/constants.ts
var constants = __webpack_require__(3379);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./components/Image/index.tsx + 2 modules
var Image = __webpack_require__(87113);
// EXTERNAL MODULE: ./components/CMS/ArticlePromotion/style.module.scss
var style_module = __webpack_require__(99139);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/CMS/ArticlePromotion/index.tsx








var ArticlePromotion = function(param) {
    var promotion = param.promotion;
    var title = promotion.title, blurb = promotion.blurb, link = promotion.link, linkStyle = promotion.linkStyle, linkText = promotion.linkText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            container: true,
            className: (style_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    md: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (style_module_default()).contents,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: title
                            }),
                            blurb && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: blurb
                            }),
                            link && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkElement/* LinkElement */.E, {
                                linkText: linkText,
                                link: link,
                                linkStyle: linkStyle,
                                align: constants/* Alignment.Left */.v2.Left
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    md: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (style_module_default()).img,
                        children: promotion.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(CmsImage/* default */.Z, {
                            layout: "fill",
                            objectFit: "cover",
                            imageProps: promotion.image,
                            altText: promotion.image.alternativeText || Image/* defaultAlt */.Zp,
                            format: "large"
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/CMS/ArticleResultLanding/index.tsx




var END_OF_FIRST_TWO_COLUMNS_DATA = 9;
var ArticleResultLanding = function(param) {
    var articles = param.articles, promotion = param.promotion;
    var firstPartAmount = articles.length < END_OF_FIRST_TWO_COLUMNS_DATA ? articles.length : END_OF_FIRST_TWO_COLUMNS_DATA;
    var firstTwoColumnsData = articles.slice(0, firstPartAmount);
    var restColumnsData = articles.slice(firstPartAmount);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleListSection/* default */.Z, {
                articles: firstTwoColumnsData
            }, "firstTwoColumn"),
            promotion && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePromotion, {
                promotion: promotion
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleListSection/* default */.Z, {
                articles: restColumnsData
            }, "restArticles")
        ]
    });
};


/***/ }),

/***/ 7098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ LinkElement; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _app_utils_useAnalytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9800);
/* harmony import */ var _cmsComponents_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3379);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(282);
/* harmony import */ var _material_ui_icons_ArrowForward__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29973);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99263);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_5__);








var LinkElement = function(param) {
    var linkText = param.linkText, link = param.link, linkStyle = param.linkStyle, _align = param.align, align = _align === void 0 ? _cmsComponents_constants__WEBPACK_IMPORTED_MODULE_2__/* .Alignment.Center */ .v2.Center : _align, buttonClassName = param.buttonClassName, trackAction = param.trackAction;
    var track = (0,_app_utils_useAnalytics__WEBPACK_IMPORTED_MODULE_1__/* .useAnalytics */ .z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().container),
        children: linkStyle === _cmsComponents_constants__WEBPACK_IMPORTED_MODULE_2__/* .LinkStyle.HyperLink */ .uj.HyperLink ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[align],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                href: link,
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().hyperLink),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: linkText
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ArrowForward__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[align],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                variant: "contained",
                color: "secondary",
                onClick: function() {
                    return track("Click", {
                        action: trackAction !== null && trackAction !== void 0 ? trackAction : "CMS Button Click",
                        "element text": linkText !== null && linkText !== void 0 ? linkText : "",
                        "element type": "button"
                    });
                },
                href: link,
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().button), (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[linkStyle || "Button"], buttonClassName),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().linkText),
                    children: linkText
                })
            })
        })
    });
};


/***/ }),

/***/ 3379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mp": function() { return /* binding */ GridDirection; },
/* harmony export */   "uj": function() { return /* binding */ LinkStyle; },
/* harmony export */   "v2": function() { return /* binding */ Alignment; }
/* harmony export */ });
/* unused harmony export LayoutBackground */
var LinkStyle;
(function(LinkStyle) {
    LinkStyle["Button"] = "Button";
    LinkStyle["HyperLink"] = "HyperLink";
    LinkStyle["MainCta"] = "MainCTA";
})(LinkStyle || (LinkStyle = {}));
var GridDirection;
(function(GridDirection) {
    GridDirection["Row"] = "row";
    GridDirection["RowReverse"] = "row-reverse";
    GridDirection["Column"] = "column";
    GridDirection["ColumnReverse"] = "column-reverse";
})(GridDirection || (GridDirection = {}));
var Alignment;
(function(Alignment) {
    Alignment["Center"] = "Center";
    Alignment["Left"] = "Left";
    Alignment["Right"] = "Right";
})(Alignment || (Alignment = {}));
var LayoutBackground;
(function(LayoutBackground) {
    LayoutBackground["Dark"] = "Dark";
    LayoutBackground["Light"] = "Light";
})(LayoutBackground || (LayoutBackground = {}));


/***/ }),

/***/ 85249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ARTICLE_RESULT_FIRST_PAGE_AMOUNT": function() { return /* binding */ ARTICLE_RESULT_FIRST_PAGE_AMOUNT; },
/* harmony export */   "ARTICLE_RESULT_REST_PAGES_AMOUNT": function() { return /* binding */ ARTICLE_RESULT_REST_PAGES_AMOUNT; },
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_lab_Pagination__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72221);
/* harmony import */ var components_CMS_ArticleListSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96386);
/* harmony import */ var components_CMS_ArticleResultLanding__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31819);
/* harmony import */ var modules_ContentHubContainer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26877);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31211);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_7__);










var __N_SSP = true;
var ARTICLE_RESULT_FIRST_PAGE_AMOUNT = 14;
var ARTICLE_RESULT_REST_PAGES_AMOUNT = 18;
var ArticlesByCategory = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var articles = props.articles, categoriesOnMenu = props.categoriesOnMenu, title = props.title, query = props.query, pageCount = props.pageCount, promotion = props.promotion, slug = props.slug, metaTitle = props.metaTitle, metaDescription = props.metaDescription;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(modules_ContentHubContainer__WEBPACK_IMPORTED_MODULE_6__/* .ContentHubContainer */ ._, {
        categories: categoriesOnMenu,
        selectedCategorySlug: slug,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: metaTitle !== null && metaTitle !== void 0 ? metaTitle : undefined,
                description: metaDescription !== null && metaDescription !== void 0 ? metaDescription : undefined,
                noindex: true,
                nofollow: true,
                openGraph: {
                    title: metaTitle !== null && metaTitle !== void 0 ? metaTitle : undefined,
                    description: metaDescription !== null && metaDescription !== void 0 ? metaDescription : undefined,
                    type: "article"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_7___default().container),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    variant: "h4",
                    component: "h1",
                    children: title
                })
            }),
            query.page === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CMS_ArticleResultLanding__WEBPACK_IMPORTED_MODULE_5__/* .ArticleResultLanding */ .E, {
                articles: articles,
                promotion: promotion
            }),
            query.page > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CMS_ArticleListSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                articles: articles
            }),
            pageCount > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_7___default().pagination),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Pagination__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    count: pageCount,
                    page: +query.page || 1,
                    variant: "outlined",
                    shape: "rounded",
                    color: "primary",
                    onChange: function(e, value) {
                        query.page = value;
                        router.push({
                            pathname: location.pathname,
                            query: query
                        });
                    }
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ArticlesByCategory);


/***/ }),

/***/ 2812:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"box":"ArticleItemTop_box__UJ9kO","cover":"ArticleItemTop_cover__5cF5X","cover__error":"ArticleItemTop_cover__error__NqQWy","image":"ArticleItemTop_image__PbWnq","topLeft":"ArticleItemTop_topLeft__GvmXa","link":"ArticleItemTop_link__icClj","blurb":"ArticleItemTop_blurb__BtpI7","titleH2":"ArticleItemTop_titleH2__bf1Zu"};

/***/ }),

/***/ 59565:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"ArticleListSection_titleContainer__HJ6MC","articles":"ArticleListSection_articles__hKDc4"};

/***/ }),

/***/ 99139:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__yUgdu","contents":"style_contents__v5veO","img":"style_img__6e5Lq"};

/***/ }),

/***/ 99263:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__Rcefn","hyperLink":"style_hyperLink__g4rtX","Center":"style_Center__DL8Bq","Left":"style_Left__zB0JX","Right":"style_Right__AjXfw","button":"style_button__gvJJG","MainCTA":"style_MainCTA__91BON","linkText":"style_linkText__cHMTR"};

/***/ }),

/***/ 31211:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__5dTrH","pagination":"style_pagination__tFUi9"};

/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
__webpack_unused_export__=y;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  /* unused reexport */ __webpack_require__(69921);
} else {}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2491,5675,4577,8612,554,9774,2888,179], function() { return __webpack_exec__(91221); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);